import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';

import { fieldDisplayValue } from '$Utils';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const ReadOnlyFieldInput = props => {
    const {
        id,
        name,
        value = '', //prevents uncontrolled input warning
        style
    } = props;

    const displayValue = fieldDisplayValue(props);

    return (
        <div id={`${id}-display`} style={style}>
            <p className={styles['read-only']}>{displayValue}</p>
            <input id={id || name} type="hidden" name={name} value={value} />
        </div>
    );
};
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(ReadOnlyFieldInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const ReadOnlyField = FieldWrapper(ReadOnlyFieldInput);
